import { Directive, ElementRef } from '@angular/core';

const ACTIVE_CLASS = 'slide-title-active';
const INACTIVE_CLASS = 'slide-title-inactive';

@Directive({
  selector: 'slide-title'
})
export class SlideTitleComponent {
  public title: string;
  public element: any;

  constructor(element: ElementRef) {
    this.element = element.nativeElement;
    this.element.setAttribute('slide-fragment', 'true');
  }

  ngOnInit() {
    this.title = this.element.innerHTML.trim();
  }
}



// WEBPACK FOOTER //
// ./src/app/slide-title.component.ts